import SceneDetailPage from './SceneDetailPage.container'
export default SceneDetailPage
